export default {
    modalGenerateImageVariations: {
        imageAIHeader: 'Lag bilde med AI',
        requestFailed: 'Forespørsel mislyktes',
        describeYourImage: 'Beskriv bildet ditt',
        numberOfVariations: 'Antall varianter',
        chooseStyle: 'Velg bildetemaet ditt',
        descriptionPlaceholder: '(eg) En åker med sennepsblomster på en sommerdag med eiketrær',
        clear: 'Tøm',
        generate: 'Generere',
        seeAll: 'Se alle',
        tryAnExample: 'Prøv et eksempel',
        tryAnother: 'Prøv en annen',
    },
};
